import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { AngularFireAuth } from '@angular/fire/auth';
import 'firebase/storage';
import { environment } from '../../../environments/environment';
import { map, shareReplay } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
//import { FirebaseApp } from '@angular/fire';
import { User } from '../model/user';
import { CookieService } from 'ngx-cookie-service';
// import { AntEnvService } from './ant.env.svc';

@Injectable()
export abstract class AbsAuthService{
    user:any;

    abstract login(email: string, password: string);
    abstract getCurrentUser();
    abstract setCurrentUser(argUser: any);
    abstract setCurrentShowHide(key: any, arg: any);
}

//@Injectable({ providedIn: 'root' })
// export class AuthService implements AbsAuthService {
    
//     user: any;
//     fullScreen: boolean = false;

//     constructor(
//         private fireAuth: AngularFireAuth
//     ) {
//         this.user = fireAuth.authState;
//     }
//     public getData(): any[] {
//         return [ 'Game of Thrones', 'Breaking Bad', 'The Walking Dead' ];
//     }
//     login(email: string, password: string): Promise<FirebaseApp.> {
//         return this.fireAuth.signInWithEmailAndPassword(email, password);
        
//     }
    
//     getCurrentUser(){
        
//         return null;
//     }
//     setCurrentUser(argUser){
//         this.user = of(argUser);
//         localStorage.setItem('currentUser', JSON.stringify(argUser)); 
        
//     }    
// }

@Injectable({providedIn: 'root'})
export class AuthApiService implements AbsAuthService{

    private readonly CONFIG_URL = 'assets/contando.json?t=' + new Date().getTime();
    private readonly CONFIG_URL_STORES = 'assets/stores.json?t=' + new Date().getTime();
    private headers4Cors = { headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };
    apiUrl: string = environment.apiUrl;
    public arrStores: [];

    isAuthOk: boolean = false;
    user: Observable<User>;
    private antEnv$: Observable<AntEnv>;

    constructor(
        private http: HttpClient,
        private _cookieService:CookieService
        //private svcAntEnv: AntEnvService
    ){
        // this.svcAntEnv.load().subscribe(res=>{
        //     if(res.apiUrl != null){
        //         this.apiUrl = res.apiUrl;
        //     }
        // });
        this.antEnv$ = this.http.get<AntEnv>(this.CONFIG_URL).pipe(
            shareReplay(1)
          );
          this.antEnv$.subscribe(res => {
            this.apiUrl = res.apiUrl;
          })
    }

    login(username:string, password:string): Observable<any>{
        var url = `${this.apiUrl}/api/user/login`;
        
        return this.http.post(url, { email: username, password: password }, this.headers4Cors);
    }
    // loginV01(username: string, password: string) {
    //     return this.http.post<any>(`${environment.apiUrl}/account/portal/class/authenticate/login`, {LoginName: username, Password: password })
    //         .pipe(map(resUser => {
    //             this.isAuthOk= false;
    //             if (resUser && resUser.Token) {   
    //                 localStorage.setItem('currentUser', JSON.stringify(resUser)); 
    //                 this.isAuthOk= true;
    //             }
    //             this.user = of(resUser);
    //             return resUser;
    //         }));
    // }
    getCurrentUser(){
        var res = localStorage.getItem('currentUser');
        if(!res){
            return null;
        }
        let currentUser = JSON.parse(res);
        if (currentUser && currentUser.token) {
            return currentUser;
        }
        return null;
    }
    setCurrentUser(argUser){
        this.user = of(argUser);
        localStorage.setItem('currentUser', JSON.stringify(argUser));
        this.isAuthOk= true;
    }
    setCurrentShowHide(key, arg){
        localStorage.setItem(key, JSON.stringify(arg));
    }
    logout() {
        var eml = this._cookieService.get('email');
        var pwd = this._cookieService.get('password');
        
        this._cookieService.deleteAll();
        
        this._cookieService.set('email',eml);
        this._cookieService.set('password',pwd);
        
        localStorage.removeItem('currentUser');
        
        localStorage.removeItem('fcmToken');
    }
}

interface AntEnv{
    apiUrl:string;
    client:string;
};
